import { jsx as _jsx } from "react/jsx-runtime";
import { getViewerIdAndKind, isBarberSessionView, isShopSessionView, useSession } from '../../../infra/session';
import { useApiQuery } from '../../../infra/api';
import { endpoints } from '../network';
import { getCustomerGroupsToShow } from './utils';
import { useCanUserSeeEngage } from '../engage-access-utils';
import { CustomerGroupsView } from './customer-groups';
import { useBarberType } from '../../../barber/barber-type/use-barber-type';
export var CustomerGroupsContainer = function () {
    var session = useSession().data;
    var isShopSession = !!session && isShopSessionView(session.view);
    var isBarberSession = !!session && isBarberSessionView(session.view);
    var viewerIdAndKind = getViewerIdAndKind(session);
    var barberType = useBarberType();
    var isStudioOwner = isBarberSession && barberType === 'studio';
    var canSeeEngage = useCanUserSeeEngage();
    var barberTypeFetched = !!barberType;
    var isCorrectViewFetched = isShopSession || (isBarberSession && barberTypeFetched);
    var _a = useApiQuery({
        endpoint: endpoints.customerGroupsQuery,
        payload: {
            ownerType: viewerIdAndKind.kind,
            ownerId: viewerIdAndKind.id,
            sendEmail: true,
            sendPush: true,
            sendSms: !isStudioOwner,
        },
        options: {
            enabled: canSeeEngage && isCorrectViewFetched,
        },
    }), customerGroups = _a.data, isFetchingCustomerGroups = _a.isFetching;
    var groupsToShow = getCustomerGroupsToShow(customerGroups);
    var canSeeCustomerGroups = isCorrectViewFetched && canSeeEngage && (isFetchingCustomerGroups || groupsToShow.length);
    if (!canSeeCustomerGroups) {
        return null;
    }
    return _jsx(CustomerGroupsView, { isLoading: isFetchingCustomerGroups, customerGroups: groupsToShow });
};
